import type { AssignChatArgs, Chat } from '@ztechapps/common.contract'
import { useActionMutation, useError, useUser } from '@ztechapps/common.hook'
import { assignChatMutation } from '../Inbox/graphql'

export type UseAssignChatToMeResult = [assignChatToMe: (chatId: string) => Promise<void>, { loading: boolean }]

// "Assign to me" on a conversation. The assignment goes through the existing assign action with the signed-in
// user; the response's `assignee` updates the cached chat, so no cache write is made here. `useActionMutation`
// catches nothing, so the rejection is reported here and never reaches the click handler.
export const useAssignChatToMe = (): UseAssignChatToMeResult => {
  const { user } = useUser()
  const { onError } = useError()
  const [assignChat, { loading }] = useActionMutation<Chat, AssignChatArgs>({ query: assignChatMutation })

  const assignChatToMe = async (chatId: string) => {
    try {
      await assignChat({ chatId, assigneeId: user._id })
    } catch (e) {
      onError(e)
    }
  }

  return [assignChatToMe, { loading }]
}
